module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "chapter3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/3.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/chapter03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I was born in Calgary, Alberta, and when I started fly fishing at age ten or eleven, the Bow was my local river,” Mike Gifford began. “For me, it was a bike ride away. As I began fishing other streams around Alberta on camping trips with my family, I began to realize how special the Bow was. Thirty years later, I’m still enthralled by this anomalous river.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Bow River flows 387 miles in a southeasterly direction from its headwaters at Bow Glacier, north of Lake Louise in Banff National Park. In its upper reaches, the Bow has all the trappings of a classic alpine trout stream—conifer-lined banks, gravelly riffles, sweeping backdrops of vertiginous mountains, and a slightly off-color tint that suggests cover for lunkers lurking just below the surface. But appearances can be deceiving. While the upper Bow does hold trout, its icy, glacier-fed waters do not sustain fish in large numbers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("East from Banff, the Canadian Rockies give way to rolling hills and then prairie. Not long after the mountains are left behind, the western edges of Calgary begin to come into a view. Once a quiet city on the edge of the plains with once-a-year notoriety for the world’s largest rodeo, Calgary has nearly tripled in size in the last forty years to over a million residents; this, thanks to an oil boom, a winter Olympics hosting coup (in 1988), and its outdoors-oriented lifestyle. The Bow River bifurcates Calgary as it rolls toward its junction with the South Saskatchewan River, ultimately reaching Hudson Bay. Generally speaking, the demands and detritus of a budding metropolis spell death (or at least considerable degradation) for a trout stream. But in the case of the Bow, Calgary’s swelling population—and more specifically, its wastewater treatment needs—have helped create a world-class fishery in the 30-odd miles of river from the city east to the rural town of Carseland. Here, wild rainbow and brown trout "), _c('em', [_vm._v("average")]), _vm._v(" near 18 inches in length and browns stretching more than 25 inches are regularly encountered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("It is the infusion of nutrients into the Bow’s clean, cold water from Calgary’s two wastewater treatment plants that are most responsible for elevating the river to blue-ribbon status. The inflow—from car wash leftovers to bathroom water—goes through a four-stage treatment process. The effluent that’s released back into the river is quite clean, though it has just enough phosphorus and nitrogen to foster an incredibly rich aquatic ecosystem. “The Bow River fishery has grown and improved as the city has grown,” said Brian Meagher, a provincial biologist with Trout Unlimited Canada who works in Calgary. “Residents have come to recognize what we have here, and the fishery has evolved as people have become more conscious of the river.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s certainly unique to have a world-class trout fishery flowing through the middle of a metropolis,” Mike continued. “I have caught trout over 2 feet in length in easy view of the skyscrapers of Calgary. Non-anglers are pretty accustomed to see fly fishers along the river corridor. We’re part of the scenery, like people walking their dogs.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the Bow, it’s not inconceivable to hook the trout of a lifetime during your lunch break and be back at the office in time for the 2:00 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M")]), _vm._v(". Work-In-Progress update meeting!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The brown and rainbow trout that call the Bow home are not native to the river. Both were introduced in the 1920s; the browns reached the river when a truck carrying 45,000 fingerlings broke down near the river before reaching its intended destination, and the driver released them into the Bow, rather than see them perish. “In the city and the stretches immediately below, there are faster runs and riffles,” Mike said. “This area is home to predominately browns, and generally the biggest browns the river yields come from within the city limits. There are times on city floats when you might think you’re in the wild, the foliage along the banks is so thick. Then you’ll come around a corner, and there are hillsides with one- and two-million-dollar houses. You might be casting a #16 Caddis as someone flips burgers on their deck. As you move downstream, the river loses some of its pitch. There are longer, slower runs as you head toward Carseland (the bottom end of the blue-ribbon section), and these lower sections mostly hold rainbows.” The Bow at this point is a large river, from 100 yards across to nearly twice that size, moving past rolling prairie land dotted with copses of hardwoods and pines. (Many anglers will float the Bow, though numerous access points allow walk-and-wade fishers a chance to find good water.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beyond its consistently large trout, the Bow is renowned for its hatches (abetted by the aforementioned wastewater plants), which begin in earnest in early July. While the golden stonefly hatch may garner the most attention from casual anglers (who can resist big "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("trout on big flies?), there are others that compete for Mike’s fancy. “Early season caddis emergences provide a neat time to be on the river. At this time—and when the golden stones start coming off—there can also be prolific hatches of pale morning duns. The Trico hatch, which usually begins in late July or early August, is also special.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like Mike, daughter Caity has grown up on the Bow, and he was privileged to be with her when she caught her first fish over 20 inches. “I was rowing the boat about 10 miles below town, and the golden stone hatch was on,” Mike recalled. “Caity was casting a Chernobyl-style pattern. One cast brought up a big brown, and she did everything right—waited for the slow eat and stuck the fish once it had taken the bug. It was 24 inches, a heavy, perfectly colored brown. She was thirteen at the time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The following year, Caity returned the favor. She rowed me down the river while I fished hoppers. As special as it was to see my daughter get her first lunker, it was even more special to catch fish while Caity rowed.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentm"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MIKE GIFFORD")]), _vm._v(" has resided in southern Alberta for most of his life and has extensive experience fishing the Bow, the Crowsnest, and the waters of southeastern British Columbia. In the mid-1980s he began guiding anglers on the Bow River and now owns Country Pleasures Fly Shop. Mike has extensive experience in freshwater with trout, bass, and pike, and in salt water with such diverse species as tarpon, bonefish, and trevally.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/ifyougo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Prime Time:")]), _vm._v(" The Bow from Calgary to Carseland is open to fishing year-round. The most famous hatches occur from late June through early August.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Getting There:")]), _vm._v(" Calgary is served by many major carriers, including Air Canada (888-247-2262; "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.aircanada.com",
      "target": "_blank"
    }
  }, [_vm._v("www.aircanada.com")]), _vm._v(") and Alaska Airlines (800-252-7522; "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.alaskaair.com",
      "target": "_blank"
    }
  }, [_vm._v("www.alaskaair.com")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Accommodations:")]), _vm._v(" Tourism Calgary (800-661-1678; "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.tourismcalgary.com",
      "target": "_blank"
    }
  }, [_vm._v("www.tourismcalgary.com")]), _vm._v(") lists the many lodging options available here.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Guides/Outfitters:")]), _vm._v(" There are a number of guides and fly shops that service anglers on the Bow, including Country Pleasures (403-271-1016; "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.countrypleasures.com",
      "target": "_blank"
    }
  }, [_vm._v("www.countrypleasures.com")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Equipment:")]), _vm._v(" A 5-weight rod equipped with a floating line will work for most situations. A local fly shop will help you identify the bugs that are working when you visit.")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0028-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("The sun rises on Jurassic Lake, where the world-record rainbow trout may very well wait.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ba8887","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 93
// module chunks = 0